import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/dropdown';
import confirm from 'components/confirm';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';

export default function CompanyActions({ company, onDelete, onEdit }) {
  if (!onDelete && !onEdit) return null;

  const confirmDelete = () => {
    const message = 'Are you sure you want to remove this company?';
    confirm(message, {
      buttonLabel: 'Remove',
      buttonStyle: 'danger',
      title: `Delete Company`
    }).then(() => {
      onDelete(company);
    }).catch(() => {});
  };

  return (
    <Dropdown absolute className="company-actions" id={`company-actions-${company.id}`}>
      <UnstyledDropdownToggle bsRole="toggle">
        <i className="fas fa-cog fa-lg text-muted clickable settings-icon" />
      </UnstyledDropdownToggle>
      <Dropdown.Menu className="dropdown-menu-right" >
        {
          onEdit &&
          <MenuItem
            eventKey="1"
            name="edit-company"
            onClick={() => onEdit(company)}
          >
            <FontAwesomeIcon
              className="mr-2 bo-menu-icon"
              fixedWidth
              icon={faPencilAlt}
              size="sm"
            />
              Edit
          </MenuItem>
        }
        {
          onDelete &&
          <MenuItem
            eventKey="2"
            name="delete-company"
            onClick={confirmDelete}
          >
            <FontAwesomeIcon
              className="mr-2 bo-menu-icon"
              fixedWidth
              icon={faTrashAlt}
              size="sm"
            />
              Delete
          </MenuItem>
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}

CompanyActions.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number
  }),
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};
